<h2>{{ 'register.manualFlow.modals.editExperience' | translate }}</h2>

<form [formGroup]="experienceForm" class="field-grid">
    <div class="field">
        <label for="editRole">{{ 'register.manualFlow.step2.role' | translate }}</label>
        <input class="otherInput" id="editRole" formControlName="role" [placeholder]="'register.step2.role.placeholder' | translate">
        <p class="error-message" *ngIf="experienceForm.get('role')?.invalid && experienceForm.get('role')?.touched">{{ 'register.manualFlow.errors.required' | translate }}</p>
    </div>
    <div class="field">
        <label for="editCompany">{{ 'register.manualFlow.step2.company' | translate }}</label>
        <input class="otherInput" id="editCompany" type="text" formControlName="company" [placeholder]="'register.step2.company.placeholder' | translate">
        <p class="error-message" *ngIf="experienceForm.get('company')?.invalid && experienceForm.get('company')?.touched">{{ 'register.manualFlow.errors.required' | translate }}</p>
    </div>
    <div class="field">
        <label for="editExpStart">{{ 'register.manualFlow.step2.start' | translate }}</label>
        <input class="otherInput" id="editExpStart" type="date" formControlName="startDate">
        <p class="error-message" *ngIf="experienceForm.get('startDate')?.invalid && experienceForm.get('startDate')?.touched">{{ 'register.manualFlow.errors.date' | translate }}</p>
    </div>
    <div class="field">
        <label for="editExpEnd">{{ 'register.manualFlow.step2.end' | translate }}</label>
        <input class="otherInput" id="editExpEnd" type="date" formControlName="endDate" [min]="experienceForm.get('startDate')?.value" [class.field-error]="experienceForm.hasError('endBeforeStart')">
        <p class="field-hint">{{ 'register.manualFlow.step2.endHelp' | translate }}</p>
        <p class="error-message" *ngIf="experienceForm.hasError('endBeforeStart')">{{ 'register.manualFlow.errors.endBeforeStart' | translate }}</p>
    </div>
    <div class="field field--full">
        <label for="editResponsibilities">{{ 'register.manualFlow.step2.responsibilities' | translate }}</label>
        <textarea class="otherInput" id="editResponsibilities" rows="3" formControlName="responsibilities" [placeholder]="'register.manualFlow.step2.responsibilitiesPlaceholder' | translate"></textarea>
        <p class="error-message" *ngIf="experienceForm.get('responsibilities')?.invalid && experienceForm.get('responsibilities')?.touched">{{ 'register.manualFlow.errors.required' | translate }}</p>
    </div>
</form>

<div class="modal-actions">
    <button type="button" class="text-button" (click)="close()">{{ 'register.manualFlow.modals.cancel' | translate }}</button>
    <button mat-raised-button color="primary" type="button" (click)="saveEditExperience()">{{ 'register.manualFlow.modals.save' | translate }}</button>
</div>
